import React from "react";
import { connect } from "react-redux";
import Dummy from "../../assets/assets/account-nav.svg";
import NipSidebar2 from "../../components/Nip/Sidebar2"
import { PropTypes } from "prop-types";
import { getStorageItem } from "../UserNav/getStorageItem";

export const NipNavbar = ({ currentUser }) => {
  let { img, compImg, name, username } = getStorageItem();

  return (
    <header className="user-nav">
      <input type="checkbox" id="nav-check" />
      <NipSidebar2 />
      <div className="user-nav-left">
        <label htmlFor="nav-check">
          <div className="user-nav-left-item1"></div>
          <div className="user-nav-left-item2"></div>
          <div className="user-nav-left-item3"></div>
        </label>
      </div>

      <div className="user-nav-right">
        <div className="user-nav-right-user">
          <div className="user-nav-right-user-image">
            <img src={img || compImg || Dummy} alt="icon" />
          </div>
          <span>{name || username}</span>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
});

NipNavbar.propTypes = {
  currentUser: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default connect(mapStateToProps, null)(NipNavbar);
